import { ICustomBinding } from '#/DefaultViewExtensionInterfaces';

import BreadCrumbBinding from '@/Infrastructure/CustomBindings/BreadCrumbBinding';
import ColumnLayoutBinding from '@/Infrastructure/CustomBindings/ColumnLayoutBinding';
import ColumnLayoutItemBinding from '@/Infrastructure/CustomBindings/ColumnLayoutItemBinding';
import ColumnLayoutRowBinding from '@/Infrastructure/CustomBindings/ColumnLayoutRowBinding';
import FilterElementBinding from '@/Infrastructure/CustomBindings/FilterElementBinding';
import FlowLayoutBinding from '@/Infrastructure/CustomBindings/FlowLayoutBinding';
import FlowLayoutItemBinding from '@/Infrastructure/CustomBindings/FlowLayoutItemBinding';
import MenuItemsBinding from '@/Infrastructure/CustomBindings/MenuItemsBinding';
import MultiSelectOptionsBinding from '@/Infrastructure/CustomBindings/MultiSelectOptionsBinding';
import PanelBarItemsBinding from '@/Infrastructure/CustomBindings/PanelBarItemsBinding';
import PreventAutoFillBinding from '@/Infrastructure/CustomBindings/PreventAutoFillBinding';
import PrincipalHistorizationPreviewItemsBinding from '@/Infrastructure/CustomBindings/PrincipalHistorizationPreviewItemsBinding';
import PrincipalHistorizationSelectionItemsBinding from '@/Infrastructure/CustomBindings/PrincipalHistorizationSelectionItemsBinding';
import RadioBoxBinding from '@/Infrastructure/CustomBindings/RadioBoxBinding';
import SelectBoxBinding from '@/Infrastructure/CustomBindings/SelectBoxBinding';
import SlideDownBinding from '@/Infrastructure/CustomBindings/SlideDownBinding';

import HotkeyBinding from '@/Infrastructure/CustomBindings/HotkeyBinding';
import CoreFrameGridBinding from '@/Infrastructure/CustomBindings/CoreFrameGridBinding';
import CleanWhitespaceBinding from '@/Infrastructure/CustomBindings/CleanWhitespaceBinding';
import DateBinding from '@/Infrastructure/CustomBindings/DateBinding';
import ErgNameBinding from '@/Infrastructure/CustomBindings/ErgNameBinding';
import TechnicalNameBinding from '@/Infrastructure/CustomBindings/TechnicalNameBinding';
import VisibilityBinding from '@/Infrastructure/CustomBindings/VisibilityBinding';
import ResizeBinding from '@/Infrastructure/CustomBindings/ResizeBinding';
import ControlBinding from '@/Infrastructure/CustomBindings/ControlBinding';
import ViewBinding from '@/Infrastructure/CustomBindings/ViewBinding';
import FactoryBinding from '@/Infrastructure/CustomBindings/FactoryBinding';
import HeightBinding from '@/Infrastructure/CustomBindings/HeightBinding';
import ControlNameBinding from '@/Infrastructure/CustomBindings/ControlNameBinding';
import ControlIdentBinding from '@/Infrastructure/CustomBindings/ControlIdentBinding';
import ScrollToBinding from '@/Infrastructure/CustomBindings/ScrollToBinding';
import CallFktBinding from '@/Infrastructure/CustomBindings/CallFktBinding';
import HighlightTextBinding from '@/Infrastructure/CustomBindings/HighlightTextBinding';
import HighlightTextArrayBinding from '@/Infrastructure/CustomBindings/HighlightTextArrayBinding';
import ReadonlyBinding from '@/Infrastructure/CustomBindings/ReadonlyBinding';
import PressEnterBinding from '@/Infrastructure/CustomBindings/PressEnterBinding';
import InteractBinding from '@/Infrastructure/CustomBindings/InteractBinding';
import StylesBinding from '@/Infrastructure/CustomBindings/StylesBinding';
import StatesBinding from '@/Infrastructure/CustomBindings/StatesBinding';
import ClassesBinding from '@/Infrastructure/CustomBindings/ClassesBinding';
import FocusBinding from '@/Infrastructure/CustomBindings/FocusBinding';
import InvalidBinding from '@/Infrastructure/CustomBindings/InvalidBinding';
import LabelledByBinding from '@/Infrastructure/CustomBindings/LabelledByBinding';
import ControlsBinding from '@/Infrastructure/CustomBindings/ControlsBinding';
import DescribedByBinding from '@/Infrastructure/CustomBindings/DescribedByBinding';
import CheckableBinding from '@/Infrastructure/CustomBindings/CheckableBinding';
import LabelColumnWidthBinding from '@/Infrastructure/CustomBindings/LabelColumnWidthBinding';
import MenuItemIsOpenBinding from '@/Infrastructure/CustomBindings/MenuItemIsOpenBinding';
import OptionsLandschaftsGroupsBinding from '@/Infrastructure/CustomBindings/OptionsLandschaftsGroupsBinding';
import OptionsLandschaftGroupLinksBinding from '@/Infrastructure/CustomBindings/OptionsLandschaftGroupLinksBinding';
import CrfRichTextEditorBinding from '@/Infrastructure/CustomBindings/CrfRichTextEditorBinding';
import SlideBinding from '@/Infrastructure/CustomBindings/SlideBinding';
import HasFocusBinding from '@/Infrastructure/CustomBindings/HasFocusBinding';
import LocatorBinding from '@/Infrastructure/CustomBindings/LocatorBinding';
import AutoLocatorBinding from '@/Infrastructure/CustomBindings/AutoLocatorBinding';
import TooltipBinding from '@/Infrastructure/CustomBindings/TooltipBinding';
import LoaderBinding from '@/Infrastructure/CustomBindings/LoaderBinding';
import WebComponentBinding from '@/Infrastructure/CustomBindings/WebComponentBinding';

export default function init() {
    const bindings: ICustomBinding[] = [
        new WebComponentBinding(),
        new HotkeyBinding(),
        new CoreFrameGridBinding(),
        new CleanWhitespaceBinding(),
        new ErgNameBinding(),
        new TechnicalNameBinding(),
        new VisibilityBinding(),
        new ResizeBinding(),
        new ControlBinding(),
        new ViewBinding(),
        new FactoryBinding(),
        new HeightBinding(),
        new ControlNameBinding(),
        new ControlIdentBinding(),
        new ScrollToBinding(),
        new CallFktBinding(),
        new HighlightTextBinding(),
        new HighlightTextArrayBinding(),
        new ReadonlyBinding(),
        new PressEnterBinding(),
        new InteractBinding(),
        new StylesBinding(),
        new StatesBinding(),
        new ClassesBinding(),
        new FocusBinding(),
        new InvalidBinding(),
        new LabelledByBinding(),
        new ControlsBinding(),
        new DescribedByBinding(),
        new CheckableBinding(),
        new LabelColumnWidthBinding(),
        new MenuItemIsOpenBinding(),
        new OptionsLandschaftsGroupsBinding(),
        new OptionsLandschaftGroupLinksBinding(),
        new CrfRichTextEditorBinding(),
        new SlideBinding(),
        new HasFocusBinding(),
        new LocatorBinding(),
        new AutoLocatorBinding(),
        new TooltipBinding(),
        new LoaderBinding(),
        new DateBinding(),
        new BreadCrumbBinding(),
        new ColumnLayoutBinding(),
        new ColumnLayoutItemBinding(),
        new ColumnLayoutRowBinding(),
        new FilterElementBinding(),
        new FlowLayoutBinding(),
        new FlowLayoutItemBinding(),
        new MenuItemsBinding(),
        new MultiSelectOptionsBinding(),
        new PanelBarItemsBinding(),
        new PreventAutoFillBinding(),
        new PrincipalHistorizationPreviewItemsBinding(),
        new PrincipalHistorizationSelectionItemsBinding(),
        new RadioBoxBinding(),
        new SelectBoxBinding(),
        new SlideDownBinding()
    ];
    for (const binding of bindings)
        binding.initBinding();
}